import { useEffect } from 'react';
import { ACTIVATION_REDIRECT_PARAM, REDIRECT_URL_PARAM } from '../constants';
import { safeGetUri } from '../utils/safe-get-uri';

/**
 * Go through all query params on this page load
 * for the redirect based ones (redirect, onboarding, activation),
 * make sure they are valid urls, and rewrite them if they are not.
 * Then updates the current url with replaceState.
 *
 * Should be done before react-router gets its hands on things.
 */
export const useInitialUrlCleanup = (): void => {
  const url = new URL(window.location.href);

  for (const param of [REDIRECT_URL_PARAM, ACTIVATION_REDIRECT_PARAM]) {
    if (url.searchParams.has(param)) {
      // make sure all of the redirect urls are full urls
      url.searchParams.set(
        param,
        new URL(
          safeGetUri(url.searchParams.get(param) as string),
          window.location.origin
        ).toString()
      );
    }
  }

  window.history.replaceState(
    window.history.state,
    'unused',
    url.toString().substring(url.origin.length)
  );
};

const useEffectUseInitialUrlCleanup = (): void => {
  useEffect(useInitialUrlCleanup);
};
export default useEffectUseInitialUrlCleanup;
